import NmsOrderPage from './NmsOrderPage';
export { NmsOrderPage };
export default NmsOrderPage;
